"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useSelectDefault = void 0;
var react_1 = require("react");
var router_1 = require("next/router");
var state_1 = require("../core/state");
/**
 * Select the element matching the curriculum in the URL query parameters
 * Or use the first element as default element
 * @param items
 * @returns
 */
var useSelectDefault = function (items) {
    var _a, _b, _c;
    var router = (0, router_1.useRouter)();
    var globalNav = (0, state_1.useGlobalNavV2)();
    var curriculumQueryParam = (_b = (_a = router === null || router === void 0 ? void 0 : router.query) === null || _a === void 0 ? void 0 : _a.curriculaCode) === null || _b === void 0 ? void 0 : _b.toString().toLowerCase();
    var selectedIndex = items.indexOf(globalNav === null || globalNav === void 0 ? void 0 : globalNav.selected) || 0;
    (0, react_1.useEffect)(function () {
        if (!items.length)
            return;
        var defaultSelected = items.find(function (item) { return item.code === curriculumQueryParam; }) || items[0];
        globalNav.select(defaultSelected);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [items === null || items === void 0 ? void 0 : items.length, (_c = router === null || router === void 0 ? void 0 : router.query) === null || _c === void 0 ? void 0 : _c.curriculaCode]);
    return { selectedIndex: selectedIndex };
};
exports.useSelectDefault = useSelectDefault;
